import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddNewMedia from "../../components/admincomponents/AddNewMedia";

function AddMedia({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddNewMedia />            
    </>
  );
}

export default AddMedia;
